import React from 'react';
import PropTypes from 'prop-types';
import classes from './title.module.scss';

const Title = (props) => {
	return <div className={classes.main__title}>
                <h1 className={classes.title}>
                    Еколого-гідрологічний геопортал гідрологічної мережі басейну Дніпра
                </h1>
            </div>
}

Title.propTypes = {
    //products: PropTypes.array
}

export default Title;